import { crudActions } from "@/services/CrudActions";
import { crudMdActions } from "@/services/CrudMdActions";

export default {
  ...crudActions("packs-horas"),
  ...crudMdActions("packs-horas"),
};
